import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { colors } from '../theme';
import EvStationIcon from '@mui/icons-material/EvStation';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

function StatsSection() {
  const stats = [
    {
      number: '200+',
      label: 'Chargers Managed',
      sublabel: 'Active installations',
      icon: <EvStationIcon sx={{ fontSize: 50 }} />,
      color: colors.yellow,
    },
    {
      number: '20+',
      label: 'Prime Locations',
      sublabel: 'Strategic sites',
      icon: <LocationOnIcon sx={{ fontSize: 50 }} />,
      color: colors.green,
    },
    {
      number: 'Island-Wide',
      label: 'Coverage',
      sublabel: 'All across Singapore',
      icon: <MapIcon sx={{ fontSize: 50 }} />,
      color: colors.yellow,
    },
    {
      number: '5+ Years',
      label: 'Industry Experience',
      sublabel: 'Proven track record',
      icon: <EmojiEventsIcon sx={{ fontSize: 50 }} />,
      color: colors.green,
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        bgcolor: colors.black,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            radial-gradient(circle at 20% 50%, rgba(255, 215, 0, 0.08) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(0, 200, 83, 0.08) 0%, transparent 50%)
          `,
          pointerEvents: 'none',
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={4}>
          {stats.map((stat, index) => (
            <Grid item xs={6} md={3} key={index}>
              <Box
                sx={{
                  textAlign: 'center',
                  p: { xs: 2, md: 3 },
                  borderRadius: 3,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    bgcolor: 'rgba(255, 255, 255, 0.05)',
                  },
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    display: 'inline-flex',
                    p: 2,
                    borderRadius: 3,
                    bgcolor: `${stat.color}20`,
                    color: stat.color,
                    mb: 2,
                  }}
                >
                  {stat.icon}
                </Box>

                {/* Number */}
                <Typography
                  sx={{
                    fontSize: { xs: '2rem', md: '2.5rem' },
                    fontWeight: 800,
                    color: stat.color,
                    mb: 1,
                    lineHeight: 1,
                  }}
                >
                  {stat.number}
                </Typography>

                {/* Label */}
                <Typography
                  sx={{
                    fontSize: { xs: '1rem', md: '1.1rem' },
                    fontWeight: 700,
                    color: colors.white,
                    mb: 0.5,
                  }}
                >
                  {stat.label}
                </Typography>

                {/* Sublabel */}
                <Typography
                  sx={{
                    fontSize: { xs: '0.8rem', md: '0.9rem' },
                    color: 'rgba(255, 255, 255, 0.6)',
                  }}
                >
                  {stat.sublabel}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default StatsSection;
